/**
 * <zigzag-timeline> - marks steps "active" as the visitor scrolls past them,
 * matching the reference site's progressive-reveal timeline.
 */
class ZigzagTimeline extends HTMLElement {
  connectedCallback() {
    this.steps = Array.from(this.querySelectorAll('.timeline__step'));
    if (!this.steps.length) return;

    this.steps[0].classList.add('is-active');

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('is-active');
        });
      },
      { rootMargin: '0px 0px -40% 0px', threshold: 0.2 }
    );

    this.steps.forEach((step) => this.observer.observe(step));
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('zigzag-timeline')) {
  customElements.define('zigzag-timeline', ZigzagTimeline);
}
